import { useState } from 'react';

import { useHistory } from 'react-router-dom';

import type { ImpersonateResponse } from 'api/types';
import { CookieKeys, cookieService } from 'shared/lib/cookies/cookieService';
import { useFiltersContext } from 'shared/lib/filters/useFiltersContext';
import { localStorageService, StorageKeys } from 'shared/lib/storage/storageService';

const setImpersonationParams = (newEmail: string, newId: string) => {
  localStorageService.set(StorageKeys.IMPERSONATION_EMAIL, newEmail);
  localStorageService.set(StorageKeys.IMPERSONATION_ID, newId);
};

export const useImpersonation = () => {
  const { resetFilters } = useFiltersContext();
  const [email, setEmail] = useState(localStorageService.get(StorageKeys.IMPERSONATION_EMAIL));
  const [id, setId] = useState(localStorageService.get(StorageKeys.IMPERSONATION_ID));
  const history = useHistory();

  return {
    impersonate: ({ target, id }: ImpersonateResponse) => {
      resetFilters();
      setImpersonationParams(target, id);
      setEmail(email);
      setId(id);
      cookieService.remove(CookieKeys.TENANT_COMPANY_ID);
      history.replace({ search: '' });
      history.go(0);
    },
    stopImpersonation: (keepSearchParams = false) => {
      resetFilters();
      setImpersonationParams('', '');
      setEmail('');
      setId('');
      cookieService.remove(CookieKeys.TENANT_COMPANY_ID);

      if (!keepSearchParams) {
        history.replace({ search: '' });
      }

      history.go(0);
    },
    [StorageKeys.IMPERSONATION_EMAIL]: email,
    [StorageKeys.IMPERSONATION_ID]: id,
  };
};
